import { render, staticRenderFns } from "./board_qna_list.vue?vue&type=template&id=2d038f71&"
import script from "./board_qna_list.vue?vue&type=script&lang=js&"
export * from "./board_qna_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports